import { Button, Modal } from "semantic-ui-react";
import PlanCard from "../layout/PlanCard";

const PlanCardModal = ({ plan, open, close, hidden }) => {
  return (
    <Modal
      className="eventsizeModal"
      size="tiny"
      dimmer={true}
      onClose={close}
      onOpen={open}
      open={hidden}
    >
      <Modal.Content className="eventNewModal">
        <div className="eventVisitorModalButton">
          <Button floated="left" circular icon="close" onClick={close} />
        </div>
        <div>
          <div className="AthleteEventsInfoContainer common-event">
            <div
              className="AthleteEventsGroupContainer onlyone"
              style={{ display: "block" }}
            >
              <div className="PackageListing new-student-package single">
                <PlanCard plan={plan} hide />
              </div>
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default PlanCardModal;
